import React from 'react'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'

const AVPU = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>AVPU</InputLabel>
      <Select value={value} onChange={onChange} label="AVPU">
        <MenuItem value="Alert">Alert</MenuItem>
        <MenuItem value="New Confusion">New Confusion</MenuItem>
        <MenuItem value="Voice">Voice</MenuItem>
        <MenuItem value="Pain">Pain</MenuItem>
        <MenuItem value="Unresponsive">Unresponsive</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default AVPU
